import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { ProgramacionesMantenimientoService, ProgramacionMantenimiento } from '../../../../shared/services/programaciones-mantenimiento.service';
import { TipoMantenimientoService } from "../../../../shared/services/tipo_mantenimiento.service";
import { OrdenMantenimientoService } from "../../../../shared/services/orden-mantenimiento.service";
import { PrioridadMantenimientoService } from "../../../../shared/services/prioridad-mantenimiento.service";
import { PrioridadMantenimiento } from '../../../../shared/model/prioridad-mantenimiento.model';
import Swal from 'sweetalert2';
import { AuthService } from '../../../../shared/services/auth.service';
import { EstadoProgramacionMantenimientosService } from '../../../../shared/services/estado-programacion-mantenimientos.services';
import { EstadoProgramacionMantenimiento, EstadoProgramacionMantenimientoRequest } from '../../../../shared/model/estados-programacion-mantenimientos.model';
import swal from 'sweetalert2';

@Component({
  selector: 'app-programacion-mantenimientos',
  templateUrl: './programacion-mantenimientos.component.html',
  styleUrls: ['./programacion-mantenimientos.component.scss']
})
export class ProgramacionMantenimientosComponent implements OnInit {

  constructor(
    private programacionesMantenimientoService: ProgramacionesMantenimientoService,
    private tipoMantenimientosService: TipoMantenimientoService,
    private prioridadMantenimientoService: PrioridadMantenimientoService,
    private ordenMantenimientoService: OrdenMantenimientoService,
    private authService: AuthService,
    private estadoProgramacionMantenimientosService: EstadoProgramacionMantenimientosService
  ) {

  }

  // Datos del listado (se conectarán al servicio)
  programaciones: ProgramacionMantenimiento[] = [];
  programacionesSeleccionadas: ProgramacionMantenimiento[] = [];
  cargando = false;

  // Búsqueda y paginación
  textoBusqueda = '';
  filtroPlaca: string = '';
  filtroPlan: string = '';
  filtroControl: string = '';
  filtroEstado: string = '';
  paginaActual = 1;
  itemsPorPagina = 10;
  opcionesItemsPorPagina = [5, 10, 25, 50, 100, 200];
  programacionSeleccionada: ProgramacionMantenimiento | null = null;
  mostrarModalDetalle = false;
  mostrarModalGenerarOrden = false;
  programacionParaOrden: ProgramacionMantenimiento | null = null;
  programacionesParaOrden: ProgramacionMantenimiento[] = [];
  prioridades: PrioridadMantenimiento[] = [];
  TipoMantenimiento: any;
  usuario_generacion_id: number | null = null;
  usuarioLogin: any = null;
  fechaInicial: string | null = null;
  fechaFinal: string | null = null;
  ordenMantenimientoForm: {
    placa: string;
    
    tipo: number;
    prioridad: number;
    fecha_programada: string;
    kilometraje_ingreso: number | null;
    motivo: string;
    observaciones: string;
  } = {
      placa: '',
      tipo: 2,
      prioridad: 1,
      fecha_programada: '',
      kilometraje_ingreso: null,
      motivo: '',
      observaciones: ''
    };

    estadosProgramacion: EstadoProgramacionMantenimientoRequest[] = [];
    estadoProgramacionSeleccionado: number | null = null;
  ngOnInit(): void {
    // TODO: cargar programaciones desde el servicio
    this.cargando = true;
   


   // this.cargarProgramaciones();
    this.cargarTiposMantenimiento();
    this.cargarPrioridades();
    this.cargarEstadosProgramacion();
    this.usuarioLogin = this.authService.getCurrentUserValue();
   // console.log(this.usuarioLogin);
    this.usuario_generacion_id = this.usuarioLogin?.id ?? null;
  }

  cargarPrioridades(): void {
    this.prioridadMantenimientoService.getAll().subscribe(
      (prioridades: PrioridadMantenimiento[]) => {
        this.prioridades = prioridades;
      },
      (error) => {
        console.error('Error al obtener las prioridades:', error);
      }
    );
  }

cargarEstadosProgramacion(): void {
   this.estadoProgramacionMantenimientosService.getEstados().subscribe({
    next: (response) => {
      this.estadosProgramacion = response.codigo === 0
        ? response.data
        : [];
    },
    error: (error) => {
      console.error('Error al cargar estados:', error);
    }
  });
}

  get programacionesFiltradas(): any[] {

    const texto = (this.textoBusqueda || '')
      .trim()
      .toLowerCase();

    return this.programaciones.filter(item => {

      /*
       * BUSQUEDA LIBRE
       */
      const coincideTexto =
        !texto ||
        [
          item.placa,
          item.plan_mantenimiento_id,
          item.actividad_id,
          item.PlanMantenimientoActividad
            ?.servicioRealizado
            ?.tipo_de_mantenimiento
        ]
          .some(valor =>
            String(valor ?? '')
              .toLowerCase()
              .includes(texto)
          );


      /*
       * VEHÍCULO
       */
      const coincidePlaca =
        !this.filtroPlaca ||
        item.placa === this.filtroPlaca;


      /*
       * PLAN
       */
      const coincidePlan =
        !this.filtroPlan ||
        String(item.plan_mantenimiento_id) ===
        String(this.filtroPlan);


      /*
       * CRITERIO
       */
      const coincideControl =
        !this.filtroControl ||
        item.PlanMantenimientoActividad?.tipoControl ===
        this.filtroControl;


      /*
       * ESTADO
       *
       * IMPORTANTE:
       * usamos el estado calculado dinámicamente.
       */
      const coincideEstado =
        !this.filtroEstado ||
        this.obtenerEstado(item) === this.filtroEstado;


      return (
        coincideTexto &&
        coincidePlaca &&
        coincidePlan &&
        coincideControl &&
        coincideEstado
      );

    });

  }

  get programacionesPaginadas(): ProgramacionMantenimiento[] {
    const inicio = (this.paginaActual - 1) * this.itemsPorPagina;
    return this.programacionesFiltradas.slice(inicio, inicio + this.itemsPorPagina);
  }

  get totalPaginas(): number {
    return Math.max(1, Math.ceil(this.programacionesFiltradas.length / this.itemsPorPagina));
  }

  get rangoMostrado(): string {
    const total = this.programacionesFiltradas.length;
    if (!total) return '0 de 0';
    const inicio = (this.paginaActual - 1) * this.itemsPorPagina + 1;
    const fin = Math.min(inicio + this.itemsPorPagina - 1, total);
    return `${inicio}-${fin} de ${total}`;
  }

  get paginasVisibles(): (number | '...')[] {
    const total = this.totalPaginas;
    const actual = this.paginaActual;
    if (total <= 7) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }
    const paginas: (number | '...')[] = [1];
    if (actual > 3) paginas.push('...');
    for (let i = Math.max(2, actual - 1); i <= Math.min(total - 1, actual + 1); i++) {
      paginas.push(i);
    }
    if (actual < total - 2) paginas.push('...');
    paginas.push(total);
    return paginas;
  }

  resetearPaginacion(): void {
    this.paginaActual = 1;
  }

  cambiarItemsPorPagina(): void {
    this.paginaActual = 1;
  }

  paginaAnterior(): void {
    if (this.paginaActual > 1) this.paginaActual--;
  }

  paginaSiguiente(): void {
    if (this.paginaActual < this.totalPaginas) this.paginaActual++;
  }

  irAPagina(p: number | '...'): void {
    if (p !== '...') this.paginaActual = p;
  }

  limpiarFiltros(): void {

    this.textoBusqueda = '';
    this.filtroPlaca = '';
    this.filtroPlan = '';
    this.filtroControl = '';
    this.filtroEstado = '';

    this.resetearPaginacion();

  }
  cargarProgramaciones(datosConsulta: any): void {
    this.cargando = true;
    // Simulación de carga de datos


    this.programacionesMantenimientoService.getProgramaciones(datosConsulta).subscribe(
      (data) => {
        this.programaciones = data.data;

        this.cargando = false;
      },
      (error) => {
        console.error('Error al cargar programaciones:', error);
        this.cargando = false;
      }
    );
  }


  calcularDiasEntreFechas(
    fechaInicio: string,
    fechaFin: string
  ): number {

    const [anioInicio, mesInicio, diaInicio] =
      fechaInicio.substring(0, 10).split('-').map(Number);

    const [anioFin, mesFin, diaFin] =
      fechaFin.substring(0, 10).split('-').map(Number);

    // Crear las fechas en UTC para evitar zona horaria local
    const inicio = Date.UTC(
      anioInicio,
      mesInicio - 1,
      diaInicio
    );

    const fin = Date.UTC(
      anioFin,
      mesFin - 1,
      diaFin
    );

    // Math.abs: sin importar el orden de las fechas, nunca devuelve negativos
    const diferencia = Math.abs(fin - inicio);

    return Math.round(
      diferencia / (1000 * 60 * 60 * 24)
    );
  }

  getFechaActual(): string {
    const fecha = new Date();
    const anio = fecha.getFullYear();
    const mes = String(fecha.getMonth() + 1).padStart(2, '0');
    const dia = String(fecha.getDate()).padStart(2, '0');
    return `${anio}-${mes}-${dia}`;
  }


  obtenerEstado(item: any): string {

    // Estados manuales que tienen prioridad
    if (item.estado === 'EN_PROCESO') {
      return 'EN PROCESO';
    }

    if (item.estado === 'PAUSADO') {
      return 'PAUSADO';
    }

    if (item.estado === 'CANCELADO') {
      return 'CANCELADO';
    }

    if (item.estado === 'EJECUTADO') {
      return 'EJECUTADO';
    }

    const tipoControl =
      item.PlanMantenimientoActividad?.tipoControl;


    // ==========================================================
    // CONTROL POR KM
    // ==========================================================

    if (tipoControl === 'KM') {

      const kilometrajeActual =
        Number(item.VehicleModel?.kilometraje);

      const proximoKm =
        Number(item.proximo_km);

      const alertaKm =
        Number(item.alerta_km);


      if (
        !Number.isFinite(kilometrajeActual) ||
        !Number.isFinite(proximoKm)
      ) {
        return 'PROGRAMADO';
      }


      // VENCIDO
      if (kilometrajeActual >= proximoKm) {
        return 'VENCIDO';
      }


      // PRÓXIMO
      if (
        Number.isFinite(alertaKm) &&
        kilometrajeActual >= alertaKm
      ) {
        return 'PRÓXIMO';
      }


      // PROGRAMADO
      return 'PROGRAMADO';
    }


    // ==========================================================
    // CONTROL POR MESES
    // ==========================================================

    if (tipoControl === 'MESES') {

      const diasRestantes =
        this.calcularDiasEntreFechas(item.proxima_fecha, this.getFechaActual());


      if (diasRestantes === null) {
        return 'PROGRAMADO';
      }


      // VENCIDO
      if (diasRestantes <= 0) {
        return 'VENCIDO';
      }


      // PRÓXIMO
      const alertaDias =
        Number(item.alerta_dias);

      if (
        Number.isFinite(alertaDias) &&
        diasRestantes <= alertaDias
      ) {
        return 'PRÓXIMO';
      }


      // PROGRAMADO
      return 'PROGRAMADO';
    }


    return 'PROGRAMADO';
  }

  obtenerClaseEstado(item: any): string {

    const estado =
      this.obtenerEstado(item);

    switch (estado) {

      case 'PROGRAMADO':
        return 'status-programado';

      case 'PRÓXIMO':
        return 'status-proximo';

      case 'VENCIDO':
        return 'status-vencido';

      case 'EN PROCESO':
        return 'status-proceso';

      case 'PAUSADO':
        return 'status-pausado';

      case 'CANCELADO':
        return 'status-cancelado';

      case 'EJECUTADO':
        return 'status-ejecutado';

      default:
        return 'status-programado';
    }
  }
  get placasDisponibles(): string[] {

    return [
      ...new Set(
        this.programaciones
          .map(item => item.placa)
          .filter(Boolean)
      )
    ].sort();

  }
  get planesDisponibles(): number[] {

    return [
      ...new Set(
        this.programaciones
          .map(item => Number(item.plan_mantenimiento_id))
          .filter(plan => Number.isFinite(plan))
      )
    ].sort((a, b) => a - b);

  }
  get hayFiltrosActivos(): boolean {

    return !!(
      this.textoBusqueda ||
      this.filtroPlaca ||
      this.filtroPlan ||
      this.filtroControl ||
      this.filtroEstado
    );



  }


  verDetalle(item: any): void {
    //console.log('Ver detalle de la programación:', item);
    this.programacionSeleccionada = item;
    this.mostrarModalDetalle = true;

  }

  cerrarModalDetalle(): void {

    this.mostrarModalDetalle = false;
    this.programacionSeleccionada = null;

  }

  abrirModalGenerarOrden(items: any[]): void {

    if (!items || items.length === 0) {
      return;
    }

    this.programacionesSeleccionadas = items;
    this.programacionesParaOrden = items;

    const primera = items[0];

    this.programacionParaOrden = primera;

    this.ordenMantenimientoForm.placa = primera.placa;
    this.ordenMantenimientoForm.tipo = 1;
    

    this.ordenMantenimientoForm.fecha_programada = this.getFechaActual();

    this.ordenMantenimientoForm.kilometraje_ingreso =
      Number(primera.VehicleModel?.kilometraje) || null;

    this.ordenMantenimientoForm.motivo = this.generarMotivoOrden(items);

    this.ordenMantenimientoForm.observaciones = '';

    this.mostrarModalGenerarOrden = true;
  }

  cerrarModalGenerarOrden(): void {

    this.mostrarModalGenerarOrden = false;
    this.programacionParaOrden = null;
    this.programacionesParaOrden = [];

  }

  private cargarTiposMantenimiento(): void {
    this.tipoMantenimientosService.getTipos().subscribe({
      next: (data) => (this.TipoMantenimiento = data),
      error: (error) =>
        console.error("❌ Error al obtener el mantenimiento:", error),
    });
  }

  /**
 * Determina si una programación puede formar parte
 * de una orden de mantenimiento.
 */
  puedeSeleccionarParaOrden(item: any): boolean {
    const estado = this.obtenerEstado(item);

    return estado === 'PRÓXIMO' || estado === 'VENCIDO' || estado === 'PROGRAMADO';
  }


  toggleSeleccionOrden(item: any): void {

    if (!this.puedeSeleccionarParaOrden(item)) {
      return;
    }

    const index = this.programacionesSeleccionadas.findIndex(
      x => x.id === item.id
    );

    // Si ya está seleccionada → quitarla
    if (index >= 0) {
      this.programacionesSeleccionadas.splice(index, 1);
      return;
    }

    // Si ya existen actividades seleccionadas,
    // solamente permitir actividades del mismo vehículo
    if (this.programacionesSeleccionadas.length > 0) {

      const placaSeleccionada =
        this.programacionesSeleccionadas[0].placa;

      if (item.placa !== placaSeleccionada) {

        // Puedes reemplazar esto por SweetAlert
        Swal.fire({
          icon: 'info',
          title: 'Selecciona el mismo vehículo',
          text: `No puedes generar una misma orden para vehículos diferentes.\n\n` +
                `Vehículo seleccionado: ${placaSeleccionada}\n` +
                `Vehículo actual: ${item.placa}`
        });

        return;
      }
    }

    this.programacionesSeleccionadas.push(item);
  }

  estaSeleccionadaParaOrden(item: any): boolean {
    return this.programacionesSeleccionadas.some(
      x => x.id === item.id
    );
  }
  get cantidadSeleccionadas(): number {
    return this.programacionesSeleccionadas.length;
  }
  get vehiculoSeleccionadoOrden(): string | null {

    if (this.programacionesSeleccionadas.length === 0) {
      return null;
    }

    return this.programacionesSeleccionadas[0].placa || null;
  }
  limpiarSeleccionOrden(): void {
    this.programacionesSeleccionadas = [];
  }

abrirModalGenerarOrdenSeleccionadas(): void {

  if (this.programacionesSeleccionadas.length === 0) {
    return;
  }

  const planId =
    this.programacionesSeleccionadas[0].plan_mantenimiento_id;

  this.programacionesMantenimientoService
    .consultarActividadPorPlan(planId)
    .subscribe({
      next: (response) => {

        if (!response || response.codigo !== 0) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: `No se pudo validar el estado de las actividades: ${
              response?.mensaje || 'Respuesta inválida del servidor.'
            }`
          });
          return;
        }

        const actividadesExistentes = response.data ?? [];

        // Estados de órdenes que impiden generar otra orden.
        const estadosOrdenActiva = [1, 2];

        const programacionesBloqueadas =
          this.programacionesSeleccionadas.filter(
            (seleccionada: any) =>
              actividadesExistentes.some(
                (actividad: any) =>
                  Number(actividad.programacion_mantenimiento_id) ===
                    Number(seleccionada.id) &&
                  estadosOrdenActiva.includes(
                    Number(actividad.orden?.estado_id)
                  )
              )
          );

        // Si hay alguna programación bloqueada, NO abrir el modal.
        if (programacionesBloqueadas.length > 0) {

          const ordenes = [
            ...new Set(
              actividadesExistentes
                .filter(
                  (actividad: any) =>
                    programacionesBloqueadas.some(
                      (seleccionada: any) =>
                        Number(seleccionada.id) ===
                        Number(actividad.programacion_mantenimiento_id)
                    ) &&
                    estadosOrdenActiva.includes(
                      Number(actividad.orden?.estado_id)
                    )
                )
                .map(
                  (actividad: any) =>
                    actividad.orden?.numero_orden
                )
                .filter(Boolean)
            )
          ];

          Swal.fire({
            icon: 'warning',
            title: 'No se puede generar la orden',
            text: `Las programaciones seleccionadas ya están asociadas a órdenes activas${
              ordenes.length
                ? ': ' + ordenes.join(', ')
                : ''
            }. Finaliza o cancela las órdenes existentes antes de continuar.`,
            confirmButtonText: 'Entendido'
          });

          return;
        }

        // Solo si todas las programaciones están disponibles,
        // preparar el formulario y abrir el modal.
        this.programacionesParaOrden = [
          ...this.programacionesSeleccionadas
        ];

        const primera = this.programacionesSeleccionadas[0];

        const actividades = this.programacionesSeleccionadas
          .map(
            (item: any) =>
              item?.PlanMantenimientoActividad
                ?.servicioRealizado
                ?.tipo_de_mantenimiento
          )
          .filter(Boolean);

        this.programacionParaOrden = primera;

        this.ordenMantenimientoForm = {
          placa: primera?.placa || '',
          tipo: 2,
          prioridad: 2,
          fecha_programada: this.getFechaActual(),

          kilometraje_ingreso:
            primera?.VehicleModel?.kilometraje != null
              ? Number(primera.VehicleModel.kilometraje)
              : null,

          motivo:
            `Mantenimiento preventivo programado: ${actividades.join(', ')}`,

          observaciones: ''
        };

        // Abrir únicamente después de validar.
        this.mostrarModalGenerarOrden = true;
      },

      error: (error) => {
        console.error(
          'Error al consultar el estado de las actividades:',
          error
        );

        Swal.fire({
          icon: 'error',
          title: 'Error de validación',
          text: 'No fue posible verificar las órdenes existentes. Intenta nuevamente.'
        });
      }
    });
}

  generarMotivoOrden(item: any): string {

    const actividad =
      item?.PlanMantenimientoActividad
        ?.servicioRealizado
        ?.tipo_de_mantenimiento;

    if (actividad) {
      return `Mantenimiento preventivo programado: ${actividad}`;
    }

    return 'Mantenimiento preventivo programado';
  }
seleccionarTodasLasVisibles(event: Event): void {
  const marcado = (event.target as HTMLInputElement).checked;

  const actividadesActivas = this.programacionesPaginadas.filter(
    (item: any) => Number(item.estado) === 1
  );

  if (marcado) {
    actividadesActivas.forEach((item: any) => {
      const yaSeleccionada = this.programacionesSeleccionadas.some(
        (seleccionada: any) =>
          Number(seleccionada.id) === Number(item.id)
      );

      if (!yaSeleccionada) {
        this.programacionesSeleccionadas.push(item);
      }
    });
  } else {
    const idsActivos = actividadesActivas.map(
      (item: any) => Number(item.id)
    );

    this.programacionesSeleccionadas =
      this.programacionesSeleccionadas.filter(
        (item: any) => !idsActivos.includes(Number(item.id))
      );
  }
}
  todasLasSeleccionablesMarcadas(): boolean {

    const seleccionables =
      this.programacionesPaginadas.filter(
        item => this.puedeSeleccionarParaOrden(item)
      );

    if (seleccionables.length === 0) {
      return false;
    }

    return seleccionables.every(
      item => this.estaSeleccionadaParaOrden(item)
    );
  }
  haySeleccionParcial(): boolean {

    const seleccionables =
      this.programacionesPaginadas.filter(
        item => this.puedeSeleccionarParaOrden(item)
      );

    const seleccionadas =
      seleccionables.filter(
        item => this.estaSeleccionadaParaOrden(item)
      );

    return (
      seleccionadas.length > 0 &&
      seleccionadas.length < seleccionables.length
    );
  }

  //generar orden de mantenimiento a partir de las actividades seleccionadas
generarOrdenMantenimiento(): void {

  // =========================================================
  // 1. VALIDAR QUE EXISTAN ACTIVIDADES SELECCIONADAS
  // =========================================================

  if (
    !this.programacionesSeleccionadas ||
    this.programacionesSeleccionadas.length === 0
  ) {
  Swal.fire({
    icon: 'warning',
    title: 'Atención',
    text: 'Debe seleccionar al menos una actividad para generar la orden.'
  });
  return;
  }


  // =========================================================
  // 2. VALIDAR QUE TODAS LAS ACTIVIDADES SEAN DEL MISMO VEHÍCULO
  // =========================================================

  const placas = [
    ...new Set(
      this.programacionesSeleccionadas
        .map(item => item.placa)
        .filter(Boolean)
    )
  ];

  if (placas.length !== 1) {
    Swal.fire({
      icon: 'warning',
      title: 'Atención',
      text: 'No puede generar una orden con actividades de vehículos diferentes.'
    });
    return;
  }

  const placa = placas[0];


  // =========================================================
  // 3. PROGRAMACIÓN PRINCIPAL
  // =========================================================

  const primeraProgramacion =
    this.programacionesSeleccionadas[0];


  // =========================================================
  // 4. VALIDAR PLAN DE MANTENIMIENTO
  // =========================================================

  if (!primeraProgramacion.plan_mantenimiento_id) {
    Swal.fire({
      icon: 'warning',
      title: 'Atención',
      text: 'La programación seleccionada no tiene un plan de mantenimiento asociado.'
    });
    return;
  }


  // =========================================================
  // 5. VALIDAR TIPO DE MANTENIMIENTO
  // =========================================================

  if (
    this.ordenMantenimientoForm.tipo === null ||
    this.ordenMantenimientoForm.tipo === undefined
  ) {
    Swal.fire({
      icon: 'warning',
      title: 'Atención',
      text: 'Debe seleccionar el tipo de mantenimiento.'
    });
    return;
  }


  // =========================================================
  // 6. VALIDAR PRIORIDAD
  // =========================================================

  if (
    this.ordenMantenimientoForm.prioridad === null ||
    this.ordenMantenimientoForm.prioridad === undefined
  ) {
    Swal.fire({
      icon: 'warning',
      title: 'Atención',
      text: 'Debe seleccionar la prioridad.'
    } );
    return;
  }


  // =========================================================
  // 7. VALIDAR FECHA PROGRAMADA
  // =========================================================

  if (
    !this.ordenMantenimientoForm.fecha_programada ||
    !this.ordenMantenimientoForm.fecha_programada.trim()
  ) {
    Swal.fire({
      icon: 'warning',
      title: 'Atención',
      text: 'Debe indicar la fecha programada.'
    });
    return;
  }


  // =========================================================
  // 8. VALIDAR KILOMETRAJE
  // =========================================================

  const kilometraje =
    this.ordenMantenimientoForm.kilometraje_ingreso;
  //console.log('Kilometraje actual del vehículo:', kilometraje);
  if (
    kilometraje === null ||
    kilometraje === undefined ||
    kilometraje === 0
  ) {
    Swal.fire({
      icon: 'warning',
      title: 'Atención',
      text: 'No se encontró el kilometraje actual del vehículo.'
    });
    return;
  }


  // =========================================================
  // 9. VALIDAR MOTIVO
  // =========================================================

  if (
    !this.ordenMantenimientoForm.motivo ||
    !this.ordenMantenimientoForm.motivo.trim()
  ) {
    Swal.fire({
      icon: 'warning',
      title: 'Atención',
      text: 'Debe ingresar el motivo de la orden de mantenimiento.'
    });
    return;
  }


  // =========================================================
  // 10. VALIDAR OBSERVACIONES
  // =========================================================

  if (
    !this.ordenMantenimientoForm.observaciones ||
    !this.ordenMantenimientoForm.observaciones.trim()
  ) {
    Swal.fire({
      icon: 'warning',
      title: 'Atención',
      text: 'Debe ingresar las observaciones de la orden de mantenimiento.'
    });
    return;
  }


  // =========================================================
  // 11. VALIDAR ACTIVIDADES
  // =========================================================

  const actividadesInvalidas =
    this.programacionesSeleccionadas.some(item =>
      !item.id ||
      !item.plan_mantenimiento_actividad_id ||
      !item.actividad_id
    );

  if (actividadesInvalidas) {
    Swal.fire({
      icon: 'warning',
      title: 'Atención',
      text: 'Una o más actividades seleccionadas no tienen la información requerida.'
    }   );
    return;
  }

  //VALIDAR USUARIO GENERACIÓN
  if (!this.usuario_generacion_id) {
    Swal.fire({
      icon: 'warning',
      title: 'Atención',
      text: 'No se encontró el usuario que genera la orden de mantenimiento.'
    });
    return;
  }


  // =========================================================
  // 12. CONSTRUIR PAYLOAD
  // =========================================================
//console.log('Construyendo payload para la orden de mantenimiento');
//console.log(primeraProgramacion);
//console.log(primeraProgramacion.id);
const payload = {
  id: primeraProgramacion.id,
  placa: placa,

  plan_mantenimiento_id:
    primeraProgramacion.plan_mantenimiento_id,

  tipo_mantenimiento_id:
    this.ordenMantenimientoForm.tipo,

  prioridad_id:
    this.ordenMantenimientoForm.prioridad,

  fecha_programada:
    this.ordenMantenimientoForm.fecha_programada,

  kilometraje_generacion:
    kilometraje,

  motivo:
    this.ordenMantenimientoForm.motivo.trim(),

  observaciones:
    this.ordenMantenimientoForm.observaciones.trim(),

  actividades:
    this.programacionesSeleccionadas.map(item => ({
      programacion_mantenimiento_id: item.id,

      plan_mantenimiento_actividad_id:
        item.plan_mantenimiento_actividad_id,

      actividad_id:
        item.actividad_id
    })),
    
};


  // =========================================================
  // 13. ÚLTIMA VALIDACIÓN DEL PAYLOAD
  // =========================================================

 /*  console.log(
    'Payload validado:',
    payload
  ); */


  // =========================================================
  // 14. AQUÍ RECIÉN SE LLAMA AL SERVICIO
  // =========================================================

    this.ordenMantenimientoService
    .create(payload)
    .subscribe({

      // ========================================================
      // RESPUESTA EXITOSA
      // ========================================================

      next: (response) => {

       /*  console.log(
          'Orden de mantenimiento creada correctamente:',
          response
        ); */


        // ---------------------------------------------
        // MENSAJE
        // ---------------------------------------------
        Swal.fire({
          icon: 'success',
          title: 'Éxito',
          text: `Orden ${response.numero_orden} generada correctamente.`
        });


        // ---------------------------------------------
        // LIMPIAR SELECCIÓN
        // ---------------------------------------------

        this.limpiarSeleccionOrden();


        // ---------------------------------------------
        // LIMPIAR FORMULARIO
        // ---------------------------------------------
        
        


        // ---------------------------------------------
        // CERRAR MODAL
        // ---------------------------------------------

        // Si utilizas NgbModal:
         this.cerrarModalGenerarOrden();


        // ---------------------------------------------
        // RECARGAR PROGRAMACIONES
        // ---------------------------------------------

       // this.cargarProgramaciones();

      },


      // ========================================================
      // ERROR
      // ========================================================

      error: (error) => {

        console.error(
          'Error al generar la orden de mantenimiento:',
          error
        );


        const mensaje =
          error?.error?.mensaje ||
          error?.error?.message ||
          error?.message ||
          'No fue posible generar la orden de mantenimiento.';


        alert(mensaje);

      }

    
    });
  }


cambiarEstadoActividad(item: any, estadoProgramacionId: number): void {

//2 PROGRAMADO
//4 EJECUADO
//5 CANCELADO
//6 PAUSADO

  let nuevoEstado = 0;
  let accion = '';
  let accionTexto = '';

  switch (estadoProgramacionId) {
    case 2:
      nuevoEstado = 2;
      accionTexto = 'Programar';
      break;
    case 4:
      nuevoEstado = 4;
      accionTexto = 'Ejecutar';
      break;
    case 5:
      nuevoEstado = 5;
      accionTexto = 'Cancelar';
      break;
    case 6:
      nuevoEstado = 6;
      accionTexto = 'Pausar';
      break;
    default:
      break;
  }

  // const nuevoEstado = PROGRAMADO ? 0 : 1;
    console.log('Nuevo estado:', nuevoEstado);
  const tipoMantenimiento =
    item.PlanMantenimientoActividad?.servicioRealizado
      ?.tipo_de_mantenimiento || 'esta actividad';

  Swal.fire({
    icon: 'warning',
    title: '¿Estás seguro?',
    text: `¿Deseas ${accionTexto.toLowerCase()} la actividad ${tipoMantenimiento}?`,
    showCancelButton: true,
    confirmButtonText: `Sí, ${accionTexto}`,
    cancelButtonText: 'Cancelar',
    confirmButtonColor: estadoProgramacionId === 2 ? '#dc3545' : '#198754'
  }).then((result) => {

    if (!result.isConfirmed) {
      return;
    }

    // const accionTexto = PROGRAMADO ? 'Inactivar' : 'Activar';
    this.programacionesMantenimientoService
      .actualizarProgramacion(item.id, { estado: nuevoEstado })
      .subscribe({
        next: () => {

          Swal.fire({
            icon: 'success',
            title: 'Éxito',
            text: estadoProgramacionId === 2
              ? 'Actividad programada correctamente.'
              : estadoProgramacionId === 4
              ? 'Actividad ejecutada correctamente.'
              : estadoProgramacionId === 5
              ? 'Actividad cancelada correctamente.'
              : estadoProgramacionId === 6
              ? 'Actividad pausada correctamente.'
              : 'Actividad actualizada correctamente.'
          });
 this.resetearPaginacion();
  let datosConsulta = {
    estado: this.estadoProgramacionSeleccionado,
    fechaInicial: this.fechaInicial,
    fechaFinal: this.fechaFinal,
    placa: this.filtroPlaca,
    plan: this.filtroPlan
  };
  //console.log('Consultando programaciones:', datosConsulta);

  //llamar el servicio para cargar las programaciones

  this.cargarProgramaciones(datosConsulta);
          //this.cargarProgramaciones();
        },
        error: (error) => {
          console.error(
            `Error al ${accionTexto.toLowerCase()} la actividad:`,
            error
          );

          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: `No fue posible ${accionTexto.toLowerCase()} la actividad.`
          });
        }
      });
  });
}


consultarProgramaciones(): void {

  // Validar estado
  if (this.estadoProgramacionSeleccionado == null) {
    swal.fire(
      'Campo obligatorio',
      'Debes seleccionar un estado de programación.',
      'warning'
    );
    return;
  }

  // Validar fecha inicial
  if (!this.fechaInicial) {
    swal.fire(
      'Campo obligatorio',
      'Debes seleccionar la fecha inicial.',
      'warning'
    );
    return;
  }

  // Validar fecha final
  if (!this.fechaFinal) {
    swal.fire(
      'Campo obligatorio',
      'Debes seleccionar la fecha final.',
      'warning'
    );
    return;
  }

  // Validar rango de fechas
  if (this.fechaInicial > this.fechaFinal) {
    swal.fire(
      'Rango de fechas inválido',
      'La fecha inicial no puede ser posterior a la fecha final.',
      'warning'
    );
    return;
  }

  // Validaciones correctas: consultar
  this.resetearPaginacion();
  let datosConsulta = {
    estado: this.estadoProgramacionSeleccionado,
    fechaInicial: this.fechaInicial,
    fechaFinal: this.fechaFinal,
    placa: this.filtroPlaca,
    plan: this.filtroPlan
  };
  //console.log('Consultando programaciones:', datosConsulta);

  //llamar el servicio para cargar las programaciones

  this.cargarProgramaciones(datosConsulta);
  
}




}